import Swiper from 'swiper/bundle';
import 'swiper/css/bundle';

document.addEventListener('DOMContentLoaded', function() {
    const rtSliders = document.querySelectorAll('.rt-swiper');

    rtSliders.forEach((rtSliderEle) => {
        const paginationEl = rtSliderEle.querySelector('.swiper-pagination');

        // find arrows in the closest .related-topics section
        const parentSection = rtSliderEle.closest('.related-topics');
        const prevBtn = parentSection.querySelector('.rt-arrow-prev');
        const nextBtn = parentSection.querySelector('.rt-arrow-next');

        new Swiper(rtSliderEle, {
            slidesPerView: 1,
            spaceBetween: 16,
            loop: true,
            navigation: {
                prevEl: prevBtn,
                nextEl: nextBtn,
            },
            pagination: {
                el: paginationEl,
                clickable: true,
            },
            breakpoints: {
                576: {
                    slidesPerView: 2,
                    spaceBetween: 24,
                },
                767: {
                    slidesPerView: 3,
                    spaceBetween: 20,
                },
                1200: {
                    slidesPerView: 5,
                    spaceBetween: 16,
                },
            },
        });
    });

});
